import { triResultatRechercheEnum } from '../enums/triResultatRechercheEnum'
import { budgetEnum, champsMenuRechercheEnum, offresCrmIdFilter, rechercheAvanceeEnum, surfaceEnum } from '../enums/champsMenuRecherche'

export interface FormulaireRechercheModel {
	[champsMenuRechercheEnum.location]: string[]
	[champsMenuRechercheEnum.typeBien]: string[]
	[champsMenuRechercheEnum.budget]: BudgetModel
	[champsMenuRechercheEnum.rechercheAvancee]: RechercheAvanceeModel
	tri: triResultatRechercheEnum
	page?: number
	[offresCrmIdFilter]: string[]
}

export interface BudgetModel {
	[budgetEnum.min]: number | null,
	[budgetEnum.max]: number | null
}

export interface RechercheAvanceeModel {
	[rechercheAvanceeEnum.meuble]: boolean
	[rechercheAvanceeEnum.surface]: SurfaceModel
	[rechercheAvanceeEnum.combienDeChambre]: string[]
	[rechercheAvanceeEnum.quelEtage]: string[]
	[rechercheAvanceeEnum.dernierEtage]: boolean
	[rechercheAvanceeEnum.prestation]: string[]
	[rechercheAvanceeEnum.parking]: number[]
	[rechercheAvanceeEnum.pmr]: boolean
	[rechercheAvanceeEnum.reference]: string
}

export interface SurfaceModel {
	[surfaceEnum.min]: number | null
	[surfaceEnum.max]: number | null
}

export const INITIAL_FORMULAIRE_RECHERCHE: FormulaireRechercheModel = {
	[champsMenuRechercheEnum.location]: [],
	[champsMenuRechercheEnum.typeBien]: [],
	[champsMenuRechercheEnum.budget]: {
		[budgetEnum.min]: null,
		[budgetEnum.max]: null
	},
	[champsMenuRechercheEnum.rechercheAvancee]: {
		[rechercheAvanceeEnum.meuble]: false,
		[rechercheAvanceeEnum.surface]: {
			[surfaceEnum.min]: null,
			[surfaceEnum.max]: null
		},
		[rechercheAvanceeEnum.combienDeChambre]: [],
		[rechercheAvanceeEnum.quelEtage]: [],
		[rechercheAvanceeEnum.dernierEtage]: false,
		[rechercheAvanceeEnum.prestation]: [],
		[rechercheAvanceeEnum.parking]: [],
		[rechercheAvanceeEnum.pmr]: false,
		[rechercheAvanceeEnum.reference]: ''
	},
	tri: triResultatRechercheEnum.disponibilite,
	[offresCrmIdFilter]: []
}